import React, { useEffect, useRef } from 'react';
import { ReactComponent as IconClose } from "../../images/svg/close.svg";
import { ReactComponent as IconMicRound } from "../../images/svg/mic-round.svg";
import { ReactComponent as IconCheckRound } from "../../images/svg/check-round.svg";
import { ReactComponent as IconCheckRoundSmall } from "../../images/svg/check-round-small.svg";
import { ReactComponent as IconMicSmall } from "../../images/svg/mic-small.svg";

const RequestToTalkDialog = ({ isOpen, onConfirm, onCancel, requestTalkNotificationShow }) => {
    const dialogRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.closest('.audio-preview .toolbox-button')) {
                return;
            }
            
            if (dialogRef.current && !dialogRef.current.contains(event.target)) {
                onCancel();
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div className="rtt-dialog-box" ref={dialogRef}>
            <span className="rtt-dialog-box-close" onClick={onCancel}>
                <IconClose/>
            </span>

            {requestTalkNotificationShow ? '' : <div className="rtt-dialog-box-title">Want to join conversation?</div>}

            <div  className="rtt-dialog-box-icon">
            {requestTalkNotificationShow ? <IconCheckRound/> : <IconMicRound/>}
            </div>

            <div className="rtt-dialog-box-content">
            {requestTalkNotificationShow ? 'Self-Unmuting request submitted. Please wait for the organizer to approve' : 'The host has disabled self-unmuting. Click "Request to Join" to speak.'}
            </div>

            <div className="rtt-dialog-box-footer">

                {requestTalkNotificationShow ? 
                (<button onClick={onCancel} aria-label="Cancel" className="rtt-dialog-box-button-confirm" type="button">
                    <IconCheckRoundSmall/>
                    <span>Okay</span>
                </button>) : 
                (
                    <>
                        <button onClick={onCancel} aria-label="Cancel" className="rtt-dialog-box-button-cancel" type="button">Cancel</button>
                        <button onClick={onConfirm} aria-label="Request to Join" className="rtt-dialog-box-button-confirm" type="submit"> 
                            <IconMicSmall/>
                            <span>Request to Join</span>
                        </button>
                    </>
                )}
                
            </div>
        </div>
    );
};

export default RequestToTalkDialog;